module.exports = __webpack_public_path__ + "static/media/pexels-garreth-brown-5721982.069cb786.jpg";